import { ActionDisabledCondition, UserAction } from '@mediahaven/shared';
import { ApiFragment, ExportLocation, RecordType, RecordTypeStructure } from '@stylehaven/components';

/* Export original (download)
 * Available when:
 *  * User has export rights
 *  * Is published or archived (== is not concept)
 *  * It is NOT deleted
 *  * It is not a representation
 *  * In sharing context
 *  * Has downloadable local exportlocations
 *
 * Disabled when:
 *  * No original representation
 */
export function GetDirectDownloadUserAction(
    record: ApiFragment,
    defaultExportLocation: ExportLocation | undefined
): UserAction {
    const isConcept: boolean = record.isConcept();

    const hasExportRights: boolean = record.hasExportRights();

    const hasLocalExportLocation: boolean = !!defaultExportLocation;
    const isRepresentation: boolean = record.getRecordType() === RecordType.Representation;
    const hasOriginal: boolean = record.getRecordStructure() !== RecordTypeStructure.Data || record.hasOriginal();

    const isDeleted: boolean = record.isDeleted();

    const availableConditions: boolean[] = [
        hasExportRights,
        !isConcept,
        !isDeleted,
        !isRepresentation,
        hasLocalExportLocation
    ];

    const disableConditions: ActionDisabledCondition[] = [{ condition: !hasOriginal, tooltip: 'general.no-original' }];

    return new UserAction(availableConditions, disableConditions);
}
